import React, { useState } from 'react';

const DiscountChart = ({ data, theme }) => {
  const [selectedTimeRange, setSelectedTimeRange] = useState('Last 30 Days');

  const timeRanges = ['Last 30 Days', 'Last 14 Days', 'Last 7 Days' ];

  const handleTimeRangeChange = (e) => {
    setSelectedTimeRange(e.target.value);
  };

  const getDiscountAmount = () => {
    if (!data) {
      return 0;
    }
    let amount;
    switch (selectedTimeRange) {
      case 'Last 7 Days':
        amount = data['Total Discount Last 7 Days'];
        break;
      case 'Last 14 Days':
        amount = data['Total Discount Last 14 Days'];
        break;
      case 'Last 30 Days':
        default:
        amount = data['Total Discount Last 30 Days'];
        break;       
    }
    return amount !== undefined && amount !== null ? amount : 0;
  };
  

  const discountAmount = getDiscountAmount();

  return (
    <div className="h-full">
      {/* Header */}
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          <div 
            className="w-3 h-3 rounded-full bg-green-500"
          ></div>
          <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">
            Total Savings
          </h3>
        </div>
        <select 
          id="timeRange" 
          onChange={handleTimeRangeChange} 
          value={selectedTimeRange}
          className="text-xs bg-gray-50 border border-gray-200 rounded-md px-2 py-1 text-gray-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-20 focus:outline-none"
        >
          {timeRanges.map((range) => (
            <option key={range} value={range}>
              {range}
            </option>
          ))}
        </select>
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center justify-center h-32">
        <div className="text-center">
          <div className="text-4xl font-bold text-green-600 mb-2">
            {discountAmount !== null && discountAmount !== undefined ? (
              `$${discountAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            ) : (
              '—'
            )}
          </div>
          <div className="text-xs text-gray-500 font-medium">
            {discountAmount !== null && discountAmount !== undefined ? 'Saved' : 'No data'}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 pt-3 border-t border-gray-100">
        <div className="flex items-center justify-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
          <span className="text-xs text-gray-500">
            {selectedTimeRange}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DiscountChart;
